export class TimeType {
    constructor(
      public id: number,
      public type: string,
      public description?: string
    ) {}
  }